module.exports = __webpack_public_path__ + "static/media/4-C.7dabcf38.webp";